import React from 'react';
import SvgIcon from './SvgIcon';

const Grid = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M.75.75h9v9h-9v-9zM.75 14.25h9v9h-9v-9zM14.25.75h9v9h-9v-9zM14.25 14.25h9v9h-9v-9z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

Grid.displayName = 'GridIcon';

export default Grid;
